import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  MotifButton,
  MotifDropdown,
  MotifDropdownItem,
  MotifIcon,
  MotifTooltip,
  MotifIconButton,
} from '@ey-xd/motif-react';
import { IconoirNavArrowDown, IconoirInfoCircle } from '@ey-xd/motif-icon';
import * as Constants from '../../constants/other';
import { useSelector } from 'react-redux';

const MasterDataManagementReitsHeader = ({
  handleAddReit,
  handleExportREITTemplate,
  handleUploadREITTemplate,
  handleDownloadMasterDataReport,
  isSystemOrEngagementAdmin,
}) => {
  let disabledInfoMessageOfNoPermission = Constants.noPermissionMessage;
  const [actionOptionsOpen, setActionOptionsOpen] = useState(false);
  const featureFlags = useSelector((state) => state.featureManagementData);
  const restrictedReportPeriodLimitFlag =
    featureFlags && featureFlags['RestrictedReportPeriodLimit'];

  return (
    <div className="row mt-3">
      <div className="col-md-2"> </div>
      <div className="col-md-10 d-flex justify-content-end">
        <div style={{ width: 'fit-content' }}>
          <MotifDropdown
            open={actionOptionsOpen}
            placement="bottom-end"
            id={'action-dropdown'}
            className="master-data-dropdown-action"
            handleClickOutside={() => setActionOptionsOpen(false)}
            trigger={
              <MotifButton
                type="button"
                variant="primary"
                onClick={() => setActionOptionsOpen(!actionOptionsOpen)}
                aria-controls={'action-dropdown'}
                id={'action-dropdown-trigger'}
                aria-expanded={actionOptionsOpen}
                aria-label="Action dropdown"
                data-testid="btnActions"
              >
                Actions{' '}
                <MotifIcon
                  iconFunction={IconoirNavArrowDown}
                  size="24"
                  fill="none"
                />
              </MotifButton>
            }
          >
            <ul role="menu">
              <li role="menuitem">
                {isSystemOrEngagementAdmin ? (
                  <MotifDropdownItem
                    type="button"
                    onClick={handleAddReit}
                    data-testid="btnAddREIT"
                    className="master-dropdown-item"
                  >
                    Add REIT
                  </MotifDropdownItem>
                ) : (
                  <div className="d-flex align-items-center">
                    <MotifDropdownItem
                      type="button"
                      className="master-dropdown-item"
                      data-testid="btnAddREIT"
                      disabled
                    >
                      Add REIT
                    </MotifDropdownItem>
                    <MotifTooltip
                      trigger={
                        <MotifIconButton
                          aria-label="Add REIT Info"
                          type="button"
                        >
                          <MotifIcon
                            iconFunction={IconoirInfoCircle}
                            size="24"
                          />
                        </MotifIconButton>
                      }
                      allowClick={false}
                      hideCloseButton={true}
                    >
                      {disabledInfoMessageOfNoPermission}
                    </MotifTooltip>
                  </div>
                )}
              </li>
              <li role="menuitem">
                <MotifDropdownItem
                  type="button"
                  onClick={() =>
                    handleExportREITTemplate(restrictedReportPeriodLimitFlag)
                  }
                  data-testid="btnExportREITImportTemplate"
                  className="master-dropdown-item"
                >
                  Export REIT Import Template
                </MotifDropdownItem>
              </li>
              <li role="menuitem">
                {isSystemOrEngagementAdmin ? (
                  <MotifDropdownItem
                    type="button"
                    onClick={handleUploadREITTemplate}
                    data-testid="btnUploadREITImportTemplate"
                    className="master-dropdown-item"
                  >
                    Upload REIT Import Template
                  </MotifDropdownItem>
                ) : (
                  <div className="d-flex align-items-center">
                    <MotifDropdownItem
                      type="button"
                      className="master-dropdown-item"
                      data-testid="btnUploadREITImportTemplate"
                      disabled
                    >
                      Upload REIT Import Template
                    </MotifDropdownItem>
                    <MotifTooltip
                      trigger={
                        <MotifIconButton
                          aria-label="Upload REIT Import Template Info"
                          type="button"
                        >
                          <MotifIcon
                            iconFunction={IconoirInfoCircle}
                            size="24"
                          />
                        </MotifIconButton>
                      }
                      allowClick={false}
                      hideCloseButton={true}
                    >
                      {disabledInfoMessageOfNoPermission}
                    </MotifTooltip>
                  </div>
                )}
              </li>
              <li role="menuitem">
                <MotifDropdownItem
                  type="button"
                  onClick={handleDownloadMasterDataReport}
                  data-testid="btnDownloadMasterDataReport"
                  className="master-dropdown-item"
                >
                  Download - Master Data Report (All Types)
                </MotifDropdownItem>
              </li>
            </ul>
          </MotifDropdown>
        </div>
      </div>
    </div>
  );
};

MasterDataManagementReitsHeader.propTypes = {
  handleAddReit: PropTypes.func,
  handleExportREITTemplate: PropTypes.func,
  handleUploadREITTemplate: PropTypes.func,
  handleDownloadMasterDataReport: PropTypes.func,
  isSystemOrEngagementAdmin: PropTypes.bool,
};

export default MasterDataManagementReitsHeader;
